(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5805],{

/***/ 67154:
/***/ (function(module) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _extends.apply(this, arguments);
}

module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 37702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ MenuItem_MenuItem; }
});

// UNUSED EXPORTS: styles

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 1 modules
var withStyles = __webpack_require__(1591);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ButtonBase/ButtonBase.js + 2 modules
var ButtonBase = __webpack_require__(4024);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/isMuiElement.js
var isMuiElement = __webpack_require__(83711);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useForkRef.js
var useForkRef = __webpack_require__(17294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/List/ListContext.js
var ListContext = __webpack_require__(66987);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/ListItem/ListItem.js












var styles = function styles(theme) {
  return {
    /* Styles applied to the (normally root) `component` element. May be wrapped by a `container`. */
    root: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      position: 'relative',
      textDecoration: 'none',
      width: '100%',
      boxSizing: 'border-box',
      textAlign: 'left',
      paddingTop: 8,
      paddingBottom: 8,
      '&$focusVisible': {
        backgroundColor: theme.palette.action.selected
      },
      '&$selected, &$selected:hover': {
        backgroundColor: theme.palette.action.selected
      },
      '&$disabled': {
        opacity: 0.5
      }
    },

    /* Styles applied to the `container` element if `children` includes `ListItemSecondaryAction`. */
    container: {
      position: 'relative'
    },

    /* Pseudo-class applied to the `component`'s `focusVisibleClassName` prop if `button={true}`. */
    focusVisible: {},

    /* Styles applied to the `component` element if dense. */
    dense: {
      paddingTop: 4,
      paddingBottom: 4
    },

    /* Styles applied to the `component` element if `alignItems="flex-start"`. */
    alignItemsFlexStart: {
      alignItems: 'flex-start'
    },

    /* Pseudo-class applied to the inner `component` element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the inner `component` element if `divider={true}`. */
    divider: {
      borderBottom: "1px solid ".concat(theme.palette.divider),
      backgroundClip: 'padding-box'
    },

    /* Styles applied to the inner `component` element if `disableGutters={false}`. */
    gutters: {
      paddingLeft: 16,
      paddingRight: 16
    },

    /* Styles applied to the inner `component` element if `button={true}`. */
    button: {
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: theme.palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the `component` element if `children` includes `ListItemSecondaryAction`. */
    secondaryAction: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positioned.
      paddingRight: 48
    },

    /* Pseudo-class applied to the root element if `selected={true}`. */
    selected: {}
  };
};
var useEnhancedEffect = typeof window === 'undefined' ? react.useEffect : react.useLayoutEffect;
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */

var ListItem = /*#__PURE__*/react.forwardRef(function ListItem(props, ref) {
  var _props$alignItems = props.alignItems,
      alignItems = _props$alignItems === void 0 ? 'center' : _props$alignItems,
      _props$autoFocus = props.autoFocus,
      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
      _props$button = props.button,
      button = _props$button === void 0 ? false : _props$button,
      childrenProp = props.children,
      classes = props.classes,
      className = props.className,
      componentProp = props.component,
      _props$ContainerCompo = props.ContainerComponent,
      ContainerComponent = _props$ContainerCompo === void 0 ? 'li' : _props$ContainerCompo,
      _props$ContainerProps = props.ContainerProps;
  _props$ContainerProps = _props$ContainerProps === void 0 ? {} : _props$ContainerProps;

  var ContainerClassName = _props$ContainerProps.className,
      ContainerProps = (0,objectWithoutProperties/* default */.Z)(_props$ContainerProps, ["className"]),
      _props$dense = props.dense,
      dense = _props$dense === void 0 ? false : _props$dense,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      _props$divider = props.divider,
      divider = _props$divider === void 0 ? false : _props$divider,
      focusVisibleClassName = props.focusVisibleClassName,
      _props$selected = props.selected,
      selected = _props$selected === void 0 ? false : _props$selected,
      other = (0,objectWithoutProperties/* default */.Z)(props, ["alignItems", "autoFocus", "button", "children", "classes", "className", "component", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "divider", "focusVisibleClassName", "selected"]);

  var context = react.useContext(ListContext/* default */.Z);
  var childContext = {
    dense: dense || context.dense || false,
    alignItems: alignItems
  };
  var listItemRef = react.useRef(null);
  useEnhancedEffect(function () {
    if (autoFocus) {
      if (listItemRef.current) {
        listItemRef.current.focus();
      } else if (false) {}
    }
  }, [autoFocus]);
  var children = react.Children.toArray(childrenProp);
  var hasSecondaryAction = children.length && (0,isMuiElement/* default */.Z)(children[children.length - 1], ['ListItemSecondaryAction']);
  var handleOwnRef = react.useCallback(function (instance) {
    // #StrictMode ready
    listItemRef.current = react_dom.findDOMNode(instance);
  }, []);
  var handleRef = (0,useForkRef/* default */.Z)(handleOwnRef, ref);

  var componentProps = (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, className, childContext.dense && classes.dense, !disableGutters && classes.gutters, divider && classes.divider, disabled && classes.disabled, button && classes.button, alignItems !== "center" && classes.alignItemsFlexStart, hasSecondaryAction && classes.secondaryAction, selected && classes.selected),
    disabled: disabled
  }, other);

  var Component = componentProp || 'li';

  if (button) {
    componentProps.component = componentProp || 'div';
    componentProps.focusVisibleClassName = (0,clsx_m/* default */.Z)(classes.focusVisible, focusVisibleClassName);
    Component = ButtonBase/* default */.Z;
  }

  if (hasSecondaryAction) {
    // Use div by default.
    Component = !componentProps.component && !componentProp ? 'div' : Component; // Avoid nesting of li > li.

    if (ContainerComponent === 'li') {
      if (Component === 'li') {
        Component = 'div';
      } else if (componentProps.component === 'li') {
        componentProps.component = 'div';
      }
    }

    return /*#__PURE__*/react.createElement(ListContext/* default.Provider */.Z.Provider, {
      value: childContext
    }, /*#__PURE__*/react.createElement(ContainerComponent, (0,esm_extends/* default */.Z)({
      className: (0,clsx_m/* default */.Z)(classes.container, ContainerClassName),
      ref: handleRef
    }, ContainerProps), /*#__PURE__*/react.createElement(Component, componentProps, children), children.pop()));
  }

  return /*#__PURE__*/react.createElement(ListContext/* default.Provider */.Z.Provider, {
    value: childContext
  }, /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({
    ref: handleRef
  }, componentProps), children));
});
 false ? 0 : void 0;
/* harmony default export */ var ListItem_ListItem = ((0,withStyles/* default */.Z)(styles, {
  name: 'MuiListItem'
})(ListItem));
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/MenuItem/MenuItem.js








var MenuItem_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: (0,esm_extends/* default */.Z)({}, theme.typography.body1, (0,defineProperty/* default */.Z)({
      minHeight: 48,
      paddingTop: 6,
      paddingBottom: 6,
      boxSizing: 'border-box',
      width: 'auto',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    }, theme.breakpoints.up('sm'), {
      minHeight: 'auto'
    })),
    // TODO v5: remove

    /* Styles applied to the root element if `disableGutters={false}`. */
    gutters: {},

    /* Styles applied to the root element if `selected={true}`. */
    selected: {},

    /* Styles applied to the root element if dense. */
    dense: (0,esm_extends/* default */.Z)({}, theme.typography.body2, {
      minHeight: 'auto'
    })
  };
};
var MenuItem = /*#__PURE__*/react.forwardRef(function MenuItem(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      component = _props$component === void 0 ? 'li' : _props$component,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      ListItemClasses = props.ListItemClasses,
      _props$role = props.role,
      role = _props$role === void 0 ? 'menuitem' : _props$role,
      selected = props.selected,
      tabIndexProp = props.tabIndex,
      other = (0,objectWithoutProperties/* default */.Z)(props, ["classes", "className", "component", "disableGutters", "ListItemClasses", "role", "selected", "tabIndex"]);

  var tabIndex;

  if (!props.disabled) {
    tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
  }

  return /*#__PURE__*/react.createElement(ListItem_ListItem, (0,esm_extends/* default */.Z)({
    button: true,
    role: role,
    tabIndex: tabIndex,
    component: component,
    selected: selected,
    disableGutters: disableGutters,
    classes: (0,esm_extends/* default */.Z)({
      dense: classes.dense
    }, ListItemClasses),
    className: (0,clsx_m/* default */.Z)(classes.root, className, selected && classes.selected, !disableGutters && classes.gutters),
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var MenuItem_MenuItem = ((0,withStyles/* default */.Z)(MenuItem_styles, {
  name: 'MuiMenuItem'
})(MenuItem));

/***/ }),

/***/ 89345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ en_GB; }
});

// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatDistance/index.js
var formatDistance = __webpack_require__(81991);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatRelative/index.js
var formatRelative = __webpack_require__(21865);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/localize/index.js
var localize = __webpack_require__(11950);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/match/index.js
var match = __webpack_require__(7219);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js
var buildFormatLongFn = __webpack_require__(49526);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-GB/_lib/formatLong/index.js

var dateFormats = {
  full: 'EEEE, d MMMM yyyy',
  long: 'd MMMM yyyy',
  medium: 'd MMM yyyy',
  short: 'dd/MM/yyyy'
};
var timeFormats = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: (0,buildFormatLongFn/* default */.Z)({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: (0,buildFormatLongFn/* default */.Z)({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: (0,buildFormatLongFn/* default */.Z)({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var _lib_formatLong = (formatLong);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-GB/index.js





/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United Kingdom).
 * @language English
 * @iso-639-2 eng
 * @author Alex [@glintik]{@link https://github.com/glintik}
 */

var locale = {
  code: 'en-GB',
  formatDistance: formatDistance/* default */.Z,
  formatLong: _lib_formatLong,
  formatRelative: formatRelative/* default */.Z,
  localize: localize/* default */.Z,
  match: match/* default */.Z,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
/* harmony default export */ var en_GB = (locale);

/***/ }),

/***/ 15155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ sv; }
});

;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/sv/_lib/formatDistance/index.js
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'mindre än en sekund',
    other: 'mindre än {{count}} sekunder'
  },
  xSeconds: {
    one: 'en sekund',
    other: '{{count}} sekunder'
  },
  halfAMinute: 'en halv minut',
  lessThanXMinutes: {
    one: 'mindre än en minut',
    other: 'mindre än {{count}} minuter'
  },
  xMinutes: {
    one: 'en minut',
    other: '{{count}} minuter'
  },
  aboutXHours: {
    one: 'ungefär en timme',
    other: 'ungefär {{count}} timmar'
  },
  xHours: {
    one: 'en timme',
    other: '{{count}} timmar'
  },
  xDays: {
    one: 'en dag',
    other: '{{count}} dagar'
  },
  aboutXWeeks: {
    one: 'ungefär en vecka',
    other: 'ungefär {{count}} vecka'
  },
  xWeeks: {
    one: 'en vecka',
    other: '{{count}} vecka'
  },
  aboutXMonths: {
    one: 'ungefär en månad',
    other: 'ungefär {{count}} månader'
  },
  xMonths: {
    one: 'en månad',
    other: '{{count}} månader'
  },
  aboutXYears: {
    one: 'ungefär ett år',
    other: 'ungefär {{count}} år'
  },
  xYears: {
    one: 'ett år',
    other: '{{count}} år'
  },
  overXYears: {
    one: 'över ett år',
    other: 'över {{count}} år'
  },
  almostXYears: {
    one: 'nästan ett år',
    other: 'nästan {{count}} år'
  }
};
var wordMapping = ['noll', 'en', 'två', 'tre', 'fyra', 'fem', 'sex', 'sju', 'åtta', 'nio', 'tio', 'elva', 'tolv'];

var formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    if (options && options.onlyNumeric) {
      result = tokenValue.other.replace('{{count}}', String(count));
    } else {
      result = tokenValue.other.replace('{{count}}', count < 13 ? wordMapping[count] : String(count));
    }
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'om ' + result;
    } else {
      return result + ' sedan';
    }
  }

  return result;
};

/* harmony default export */ var _lib_formatDistance = (formatDistance);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js
var buildFormatLongFn = __webpack_require__(49526);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/sv/_lib/formatLong/index.js

var dateFormats = {
  full: 'EEEE d MMMM y',
  long: 'd MMMM y',
  medium: 'd MMM y',
  short: 'y-MM-dd'
};
var timeFormats = {
  full: "'kl'. HH:mm:ss zzzz",
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
var formatLong = {
  date: (0,buildFormatLongFn/* default */.Z)({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: (0,buildFormatLongFn/* default */.Z)({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: (0,buildFormatLongFn/* default */.Z)({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var _lib_formatLong = (formatLong);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/sv/_lib/formatRelative/index.js
var formatRelativeLocale = {
  lastWeek: "'i' EEEE's kl.' p",
  yesterday: "'igår kl.' p",
  today: "'idag kl.' p",
  tomorrow: "'imorgon kl.' p",
  nextWeek: "EEEE 'kl.' p",
  other: 'P'
};

var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};

/* harmony default export */ var _lib_formatRelative = (formatRelative);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/_lib/buildLocalizeFn/index.js
var buildLocalizeFn = __webpack_require__(88486);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/sv/_lib/localize/index.js

var eraValues = {
  narrow: ['f.Kr.', 'e.Kr.'],
  abbreviated: ['f.Kr.', 'e.Kr.'],
  wide: ['före Kristus', 'efter Kristus']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1:a kvartalet', '2:a kvartalet', '3:e kvartalet', '4:e kvartalet']
};
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['jan.', 'feb.', 'mars', 'apr.', 'maj', 'juni', 'juli', 'aug.', 'sep.', 'okt.', 'nov.', 'dec.'],
  wide: ['januari', 'februari', 'mars', 'april', 'maj', 'juni', 'juli', 'augusti', 'september', 'oktober', 'november', 'december']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'O', 'T', 'F', 'L'],
  short: ['sö', 'må', 'ti', 'on', 'to', 'fr', 'lö'],
  abbreviated: ['sön', 'mån', 'tis', 'ons', 'tors', 'fre', 'lör'],
  wide: ['söndag', 'måndag', 'tisdag', 'onsdag', 'torsdag', 'fredag', 'lördag']
}; // https://www.unicode.org/cldr/charts/32/summary/sv.html#1888

var dayPeriodValues = {
  narrow: {
    am: 'fm',
    pm: 'em',
    midnight: 'midnatt',
    noon: 'middag',
    morning: 'morg.',
    afternoon: 'efterm.',
    evening: 'kväll',
    night: 'natt'
  },
  abbreviated: {
    am: 'f.m.',
    pm: 'e.m.',
    midnight: 'midnatt',
    noon: 'middag',
    morning: 'morgon',
    afternoon: 'efterm.',
    evening: 'kväll',
    night: 'natt'
  },
  wide: {
    am: 'förmiddag',
    pm: 'eftermiddag',
    midnight: 'midnatt',
    noon: 'middag',
    morning: 'morgon',
    afternoon: 'eftermiddag',
    evening: 'kväll',
    night: 'natt'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'fm',
    pm: 'em',
    midnight: 'midnatt',
    noon: 'middag',
    morning: 'på morg.',
    afternoon: 'på efterm.',
    evening: 'på kvällen',
    night: 'på natten'
  },
  abbreviated: {
    am: 'fm',
    pm: 'em',
    midnight: 'midnatt',
    noon: 'middag',
    morning: 'på morg.',
    afternoon: 'på efterm.',
    evening: 'på kvällen',
    night: 'på natten'
  },
  wide: {
    am: 'fm',
    pm: 'em',
    midnight: 'midnatt',
    noon: 'middag',
    morning: 'på morgonen',
    afternoon: 'på eftermiddagen',
    evening: 'på kvällen',
    night: 'på natten'
  }
};

var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
      case 2:
        return number + ':a';
    }
  }

  return number + ':e';
};

var localize = {
  ordinalNumber: ordinalNumber,
  era: (0,buildLocalizeFn/* default */.Z)({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: (0,buildLocalizeFn/* default */.Z)({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: (0,buildLocalizeFn/* default */.Z)({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: (0,buildLocalizeFn/* default */.Z)({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: (0,buildLocalizeFn/* default */.Z)({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ var _lib_localize = (localize);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/_lib/buildMatchFn/index.js
var buildMatchFn = __webpack_require__(76723);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/_lib/buildMatchPatternFn/index.js
var buildMatchPatternFn = __webpack_require__(60974);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/sv/_lib/match/index.js


var matchOrdinalNumberPattern = /^(\d+)(:a|:e)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
  abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
  wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
};
var parseEraPatterns = {
  any: [/^f/i, /^[ev]/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](:a|:e)? kvartalet/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar[s]?|apr|maj|jun[i]?|jul[i]?|aug|sep|okt|nov|dec)\.?/i,
  wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtofl]/i,
  short: /^(sö|må|ti|on|to|fr|lö)/i,
  abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
  wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
};
var parseDayPatterns = {
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
};
var matchDayPeriodPatterns = {
  any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^f/i,
    pm: /^e/i,
    midnight: /^midn/i,
    noon: /^midd/i,
    morning: /morgon/i,
    afternoon: /eftermiddag/i,
    evening: /kväll/i,
    night: /natt/i
  }
};
var match = {
  ordinalNumber: (0,buildMatchPatternFn/* default */.Z)({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: (0,buildMatchFn/* default */.Z)({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: (0,buildMatchFn/* default */.Z)({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: (0,buildMatchFn/* default */.Z)({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: (0,buildMatchFn/* default */.Z)({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: (0,buildMatchFn/* default */.Z)({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ var _lib_match = (match);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/sv/index.js





/**
 * @type {Locale}
 * @category Locales
 * @summary Swedish locale.
 * @language Swedish
 * @iso-639-2 swe
 * @author Johannes Ulén [@ejulen]{@link https://github.com/ejulen}
 * @author Alexander Nanberg [@alexandernanberg]{@link https://github.com/alexandernanberg}
 * @author Henrik Andersson [@limelights]{@link https://github.com/limelights}
 */

var locale = {
  code: 'sv',
  formatDistance: _lib_formatDistance,
  formatLong: _lib_formatLong,
  formatRelative: _lib_formatRelative,
  localize: _lib_localize,
  match: _lib_match,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
/* harmony default export */ var sv = (locale);

/***/ }),

/***/ 41143:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {}

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),

/***/ 80973:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var camel2hyphen = __webpack_require__(71169);

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and '
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', '
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

module.exports = json2mq;

/***/ }),

/***/ 88306:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(83369);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ 210:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}

function SvgArrowRightIcon(props) {
  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", _objectSpread(_objectSpread({
      height: 20,
      width: 20,
      viewBox: "0 0 15 12",
      xmlns: "http://www.w3.org/2000/svg" },
    props), {}, { children: /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M9 0l-.825.825 4.5 4.575H0v1.2h12.675l-4.5 4.575L9 12l6-6z",
        fill: "#243240",
        fillRule: "evenodd" }) })));



}

/* harmony default export */ __webpack_exports__["Z"] = (SvgArrowRightIcon);

/***/ }),

/***/ 28231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}

function SvgLightingIcon(props) {
  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
      width: 14,
      height: 16,
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink" },
    props), {}, { children: [/*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("defs", { children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
          d: "M13.26 5.733c-.132-.266-.332-.4-.599-.4H7.4l.6-4.6c.066-.266-.133-.6-.4-.666a.635.635 0 00-.8.2l-6.66 8c-.133.2-.2.466-.066.733a.7.7 0 00.6.333h5.261l-.6 4.6c-.066.267.134.6.4.667.067.067.2.067.267.067.2 0 .4-.067.532-.267l6.661-8c.133-.2.2-.467.067-.667zM6.934 11.8l.4-3.067c0-.2-.067-.4-.133-.533a.756.756 0 00-.533-.2H2.07l4.263-5.133L6 5.933c0 .2.066.4.133.534a.72.72 0 00.466.2h4.596L6.933 11.8z",
          id: "lighting-icon_svg__a" }) }), /*#__PURE__*/


      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("use", {
        fill: "#213E3D",
        fillRule: "nonzero",
        xlinkHref: "#lighting-icon_svg__a",
        transform: "translate(.333 .667)" })] })));



}

/* harmony default export */ __webpack_exports__["Z"] = (SvgLightingIcon);

/***/ }),

/***/ 87977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54444);
/* harmony import */ var _layout_Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94007);
/* harmony import */ var _texts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45945);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);
var _excluded = ["data-testid"];















var EmptyResults = function EmptyResults(_ref) {var _ref$dataTestid = _ref[
  'data-testid'],dataTestId = _ref$dataTestid === void 0 ? 'EmptyResults' : _ref$dataTestid,
  props = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);return /*#__PURE__*/(

    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
      className: props.className,
      my: "50px",
      flexDirection: "column",
      alignItems: "center", children: [/*#__PURE__*/


      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { mb: "30px", children: [/*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, { name: props.icon, fontSize: "84px", color: "#7D7D7D;" }),
        props.children && props.children] }), /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { mb: "10px", children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_texts__WEBPACK_IMPORTED_MODULE_3__/* .EmptyResultsText */ .xM, { children: props.title }) }),

      props.description ? /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { mb: "10px", children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_texts__WEBPACK_IMPORTED_MODULE_3__/* .EmptyResultsDescription */ .ZE, { children: props.description }) }) :

      null,
      props.action ? /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_texts__WEBPACK_IMPORTED_MODULE_3__/* .EmptyResultsTextAction */ .aC, { children: props.action }) }) :

      null,
      props.button ? props.button : null] }));};



/* harmony default export */ __webpack_exports__["Z"] = (EmptyResults);

/***/ }),

/***/ 9128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);

















var MetaTags = function MetaTags(props) {var _props$description, _props$description2;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();

  var thumbnail = "https://devenv.yogobe.com" + '/static/opengraph.png';
  if (props.thumbnailUrl) {var _props$thumbnailUrl, _props$thumbnailUrl2;
    if (
    (_props$thumbnailUrl = props.thumbnailUrl) !== null && _props$thumbnailUrl !== void 0 && _props$thumbnailUrl.startsWith('http') || (_props$thumbnailUrl2 =
    props.thumbnailUrl) !== null && _props$thumbnailUrl2 !== void 0 && _props$thumbnailUrl2.startsWith('//'))
    {
      thumbnail = props.thumbnailUrl;
    } else {
      thumbnail = "https://devenv.yogobe.com" + props.thumbnailUrl;
    }
  }

  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), { children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("title", { children: props.title + ' - Yogobe' }),
      props.description ? /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { name: "description", content: props.description }) :
      null, /*#__PURE__*/


      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "og:url", content: "https://devenv.yogobe.com" + router.asPath }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "og:type", content: "article" }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "og:title", content: props.title + ' - Yogobe' }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "og:description", content: (_props$description = props.description) !== null && _props$description !== void 0 ? _props$description : '' }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "og:image", content: thumbnail }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "fb:app_id", content: "313516218776996" }), /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", {
        property: "twitter:title",
        content: "Yoga och tr\xE4ning online f\xF6r h\xE5llbar h\xE4lsa | YOGOBE - Yogobe" }), /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "twitter:title", content: props.title + ' - Yogobe' }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "twitter:card", content: (_props$description2 = props.description) !== null && _props$description2 !== void 0 ? _props$description2 : '' }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "twitter:site", content: "https://devenv.yogobe.com" }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "twitter:image", content: thumbnail }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "twitter:creator", content: "Yogobe" }),
      props.brand && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "product:brand", content: props.brand }),


      props.availability && /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "product:availability", content: props.availability }),


      props.condition && /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "product:condition", content: props.condition }),


      typeof props.price === 'number' && /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "product:price:amount", content: props.price }),


      props.currency && /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "product:price:currency", content: props.currency }),


      props.retailerId && /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "product:retailer_item_id", content: props.retailerId })] }));



};

/* harmony default export */ __webpack_exports__["Z"] = (MetaTags);

/***/ }),

/***/ 45330:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31157);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}


var Input = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].input.withConfig({ displayName: "Input2__Input", componentId: "sc-1orwxqf-0" })(["width:100%;background-color:", ";padding:11px;font-size:16px;outline:0;border:1px solid ", ";border-top-left-radius:5px;border-bottom-left-radius:5px;", ""],





function (props) {return props.theme.colors.neutrals.white;},




function (props) {return (
    props.errorStyle ?
    props.theme.colors.secondary['red-1'] :
    props.theme.colors.interactive['color-18']);},


function (props) {return (
    props.borderRadiusComplete ? "\n          border-top-right-radius: 5px;\n          border-bottom-right-radius: 5px;\n        " :




    '');});
















var Input2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
function (props, ref) {return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Input, _objectSpread({
      ref: ref,
      type: props.type,
      id: props.id,
      value: props.value,
      readOnly: props.readOnly,
      onChange: props.onChange,
      onClick: props.onClick,
      errorStyle: props.errorStyle,
      style: props.style,
      borderRadiusComplete: props.borderRadiusComplete },
    props)));});




/* harmony default export */ __webpack_exports__["Z"] = (Input2);

/***/ }),

/***/ 76611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31157);
/* harmony import */ var _material_ui_core_MenuItem__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(37702);
/* harmony import */ var _material_ui_core_Select__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94924);
/* harmony import */ var _layout_Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94007);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1591);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);
var _excluded = ["native"];function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}






var StyledSelectWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu).withConfig({ displayName: "Select__StyledSelectWrapper", componentId: "sc-e5dpz5-0" })(["position:relative;.MuiInput-underline:after{border-color:transparent;}.MuiInput-underline:hover:not(.MuiInput-disabled):not(.MuiInput-focused):not(.MuiInput-error):before{border:0;}.MuiInput-underline:before{border:0;}.MuiSelect-select:focus{background-color:transparent;}.MuiSelect-nativeInput{position:absolute;opacity:0;}"]);





















var styles = {
  paper: {
    marginTop: '3px',
    textTransform: 'capitalize' } };



var GetStartedSectionStyledSelect = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(_material_ui_core_Select__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).attrs({
  classes: { root: 'root', selectMenu: 'selectMenu', select: 'select' } }).withConfig({ displayName: "Select__GetStartedSectionStyledSelect", componentId: "sc-e5dpz5-1" })(["width:100%;height:100%;.root{width:100%;height:100%;border:0;border-radius:5px;background-color:white;box-shadow:0 2px 4px 0 rgba(0,0,0,0.05);}.select{padding:14px;font-size:16px;font-weight:600;}"]);



















var StyledSelect = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(_material_ui_core_Select__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).attrs({
  classes: { root: 'root', selectMenu: 'selectMenu', select: 'select' } }).withConfig({ displayName: "Select__StyledSelect", componentId: "sc-e5dpz5-2" })(["width:100%;height:100%;.root{width:100%;height:100%;border:solid 1px #eaeaea;border-radius:5px;}.select{padding:12px 24px;font-size:13px;min-width:100px;}"]);
















var SelectItem = function SelectItem(props) {
  var _native = props["native"],rest = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(props, _excluded);
  return _native ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("option", _objectSpread({}, rest)) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_material_ui_core_MenuItem__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, _objectSpread({}, rest));
};























var SelectDropDown = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
  paper: {
    marginTop: '3px',
    textTransform: 'capitalize' } })(

function (props) {
  var valueKey = props.valueKey ? props.valueKey : 'value';
  var displayTextKey = props.displayTextKey ? props.displayTextKey : 'name';
  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledSelectWrapper, { className: props.className, children:
      props.getStartedStyling ? /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(GetStartedSectionStyledSelect, {
        id: props.id,
        name: props.name,
        value: props.selectedValue,
        onChange: props.onChange,
        MenuProps: {
          getContentAnchorEl: null,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right' },

          transformOrigin: {
            vertical: 'top',
            horizontal: 'right' },

          classes: {
            paper: props.classes.paper } },


        defaultValue: props.defaultValue, children:


        props.options.map(function (item, index) {return /*#__PURE__*/(
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_material_ui_core_MenuItem__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, { value: item[valueKey], children:
              item[displayTextKey] }, index));}) }) : /*#__PURE__*/




      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledSelect, {
        id: props.id,
        name: props.name,
        "native": props["native"],
        value: props.selectedValue,
        onChange: props.onChange,
        disabled: props.disabled,
        MenuProps: {
          getContentAnchorEl: null,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right' },

          transformOrigin: {
            vertical: 'top',
            horizontal: 'right' },

          classes: {
            paper: props.classes.paper } },


        defaultValue: props.defaultValue, children:


        props.options.map(function (item, index) {return /*#__PURE__*/(
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(SelectItem, {

              value: item[valueKey],
              "native": props["native"], children:

              item[displayTextKey] }, index));}) }) }));






});

/* harmony default export */ __webpack_exports__["Z"] = (SelectDropDown);

/***/ }),

/***/ 43725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Xe": function() { return /* binding */ getEventSpotsStatus; },
/* harmony export */   "_B": function() { return /* binding */ getFormattedPrice; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(31157);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _lingui_react__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(85169);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(42298);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(58545);
/* harmony import */ var date_fns_locale__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(89345);
/* harmony import */ var date_fns_locale__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(15155);
/* harmony import */ var date_fns_locale__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(3304);
/* harmony import */ var date_fns_locale__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(40302);
/* harmony import */ var _ProgressIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88460);
/* harmony import */ var _assets_LightingIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28231);
/* harmony import */ var _assets_ArrowRightIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(210);
/* harmony import */ var _lib_contexts_languageContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17516);
/* harmony import */ var _lib_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22498);
/* harmony import */ var _gql_generated__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48354);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85893);














var Card = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].a.withConfig({ displayName: "EventListingCard__Card", componentId: "sc-abnnh0-0" })(["display:flex;flex-direction:column;color:#243240;text-decoration:none;border-radius:4px;padding:20px 15px;background-color:#F0F5FB;overflow:hidden;", ""],









function (_ref) {var expired = _ref.expired;return expired ? 'opacity: 0.7;' : '';});


var Head = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].div.withConfig({ displayName: "EventListingCard__Head", componentId: "sc-abnnh0-1" })(["display:grid;grid-template-areas:\"Date Booking\" \"Month Time\";font-size:14px;color:#243240;line-height:1.2;margin-bottom:20px;"]);









var EventMonth = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].span.withConfig({ displayName: "EventListingCard__EventMonth", componentId: "sc-abnnh0-2" })(["grid-area:Month;text-transform:capitalize;"]);




var EventDate = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].span.withConfig({ displayName: "EventListingCard__EventDate", componentId: "sc-abnnh0-3" })(["grid-area:Date;font-size:32px;font-weight:600;"]);





var Time = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].span.withConfig({ displayName: "EventListingCard__Time", componentId: "sc-abnnh0-4" })(["grid-area:Time;text-align:right;"]);




var BookingStatus = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].p.withConfig({ displayName: "EventListingCard__BookingStatus", componentId: "sc-abnnh0-5" })(["grid-area:Booking;display:flex;align-items:center;justify-content:flex-end;text-align:right;text-transform:uppercase;margin:0;svg{margin-right:5px;}"]);













var Body = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].div.withConfig({ displayName: "EventListingCard__Body", componentId: "sc-abnnh0-6" })(["flex:1;display:flex;flex-direction:column;min-height:345px;"]);






var ImageWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].div.withConfig({ displayName: "EventListingCard__ImageWrapper", componentId: "sc-abnnh0-7" })(["position:relative;display:flex;margin-bottom:20px;:before{content:\"\";display:block;width:100%;padding-top:50%;}"]);












var Tags = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].div.withConfig({ displayName: "EventListingCard__Tags", componentId: "sc-abnnh0-8" })(["position:absolute;left:8px;bottom:8px;display:flex;"]);






var Tag = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].p.withConfig({ displayName: "EventListingCard__Tag", componentId: "sc-abnnh0-9" })(["font-size:11px;", " font-weight:400;text-transform:uppercase;border-radius:3px;padding:5px;margin:0 5px 0 0;background-color:white;:empty{display:none;}"],

function (_ref2) {var color = _ref2.color;return color ? "color: ".concat(color, ";") : '';});












var Img = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__["default"])((next_image__WEBPACK_IMPORTED_MODULE_8___default())).withConfig({ displayName: "EventListingCard__Img", componentId: "sc-abnnh0-10" })(["position:absolute;left:0;top:0;height:100%;width:100%;object-fit:cover;border-radius:4px;"]);









var Title = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].p.withConfig({ displayName: "EventListingCard__Title", componentId: "sc-abnnh0-11" })(["font-size:24px;font-weight:600;line-height:1.3;margin:0 0 10px;"]);






var InstructorName = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].p.withConfig({ displayName: "EventListingCard__InstructorName", componentId: "sc-abnnh0-12" })(["font-size:14px;margin:0;"]);




var Price = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].p.withConfig({ displayName: "EventListingCard__Price", componentId: "sc-abnnh0-13" })(["flex:1;display:flex;align-items:flex-end;font-size:16px;margin-bottom:15px;"]);







var Footer = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].div.withConfig({ displayName: "EventListingCard__Footer", componentId: "sc-abnnh0-14" })(["height:60px;display:flex;align-items:center;justify-content:space-between;color:#213E3D;font-weight:500;border-bottom:5px solid #BECCD9;padding:0 20px 0 15px;margin:0 -15px -20px -15px;background-color:#D5E0EC;cursor:pointer;span{flex:1;margin-left:10px;}"]);


















var localeMap = {
  en: date_fns_locale__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z,
  se: date_fns_locale__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z,
  no: date_fns_locale__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z,
  fi: date_fns_locale__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z };








var getFormattedPrice = function getFormattedPrice(event) {
  var price = event.price;
  var amount = price.originalPrice;
  if (price.discountedPrice !== null) {
    amount = price.discountedPrice;
  }
  return "".concat(Math.round(amount / 100).toFixed(2), " ").concat(price.currency);
};

var getEventSpotsStatus = function getEventSpotsStatus(
event)
{
  if (event.isExpired) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_15__/* .Trans */ .cC, { id: "live.event_page.expired_event" });
  } else if (event.isComingSoon) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_15__/* .Trans */ .cC, { id: "live.event_page.coming_soon" });
  } else if (event.availableSpots === 0) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_15__/* .Trans */ .cC, { id: "live.event_page.fully_booked_event" });
  } else if (event.availableSpots <= 10) {
    return /*#__PURE__*/(
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_15__/* .Trans */ .cC, {
        id: "live.event_page.spots_left",
        values: { spots: event.availableSpots } }));


  }

  return null;
};

var EventCard = function EventCard(_ref3) {var _event$instructors, _event$instructors$;var _ref3$className = _ref3.className,className = _ref3$className === void 0 ? '' : _ref3$className,event = _ref3.event,hasAccess = _ref3.hasAccess;
  var lang = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_lib_contexts_languageContext__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z);
  var eventDate = new Date(event.eventDates[0]);
  var day = (0,date_fns__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(eventDate, 'dd');
  var month = (0,date_fns__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(eventDate, 'MMMM', { locale: localeMap[lang] });

  var percentage =
  (event.maximumParticipants - event.availableSpots) * 100 /
  event.maximumParticipants;

  var startTime = (0,date_fns__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(eventDate, 'HH:mm');
  var endTime = (0,date_fns__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(eventDate, event.duration), 'HH:mm OOO');

  var priceText = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    if (event.kind === _gql_generated__WEBPACK_IMPORTED_MODULE_7__/* .LiveEventKind.DonationClass */ .nMP.DonationClass) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_15__/* .Trans */ .cC, { id: "live.event_page.donation_class" });
    } else if (event.price.originalPrice === 0) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_15__/* .Trans */ .cC, { id: "live.event_page.event_free" });
    } else if (event.price.discountedPrice === 0) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_15__/* .Trans */ .cC, { id: "live.event_page.for_for_you" });
    } else {
      return getFormattedPrice(event);
    }
  }, [event === null || event === void 0 ? void 0 : event.id]);

  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), { href: "/".concat(lang, "/live/").concat(event.slug), prefetch: false, legacyBehavior: true, children: /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(Card, {
        className: className,
        href: "/".concat(lang, "/live/").concat(event.slug),
        expired: event.isExpired, children: [/*#__PURE__*/


        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(Head, { children: [/*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(EventDate, { children: day }), /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(EventMonth, { children: month }), /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(BookingStatus, { children: [
            !event.isExpired && getEventSpotsStatus(event) ? /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_ProgressIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { percentage: percentage }) :
            null,
            getEventSpotsStatus(event)] }), /*#__PURE__*/

          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(Time, { children: [
            startTime, " - ", endTime] })] }), /*#__PURE__*/


        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(Body, { children: [/*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(ImageWrapper, { children: [/*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(Img, { src: event.thumbnail, alt: "", width: 275, height: 140 }), /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(Tags, { children: [/*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(Tag, { children: _lib_constants__WEBPACK_IMPORTED_MODULE_6__/* .LIVE_KINDS */ .sU[event.kind] }),
              hasAccess ? /*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(Tag, { color: "#32847E", children: /*#__PURE__*/
                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_15__/* .Trans */ .cC, { id: "live.event_page.you_r_in_event" }) }) :

              null] })] }), /*#__PURE__*/


          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(Title, { children: event.title }), /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(InstructorName, { children: (_event$instructors = event.instructors) === null || _event$instructors === void 0 ? void 0 : (_event$instructors$ = _event$instructors[0]) === null || _event$instructors$ === void 0 ? void 0 : _event$instructors$.name }), /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(Price, { children: priceText })] }), /*#__PURE__*/

        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(Footer, { children: [/*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_assets_LightingIcon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}), /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", { children: event.theme }), /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_assets_ArrowRightIcon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})] })] }) }));




};

/* harmony default export */ __webpack_exports__["ZP"] = (EventCard);

/***/ }),

/***/ 88460:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31157);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



var SVG = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].svg.withConfig({ displayName: "ProgressIcon__SVG", componentId: "sc-138o9cm-0" })(["width:18px;height:18px;transform:rotate(180deg);circle{stroke-dashoffset:0;transition:stroke-dashoffset 1s linear;stroke:#ababab;stroke-width:2px;}#bar{stroke:#213E3D;}"]);
















var ProgressIcon = function ProgressIcon(_ref) {var percentage = _ref.percentage;
  var r = 8; // 10 - 2px for stroke
  var c = Math.PI * (r * 2);

  var val = percentage;
  if (val < 0) {
    val = 0;
  } else if (val > 100) {
    val = 100;
  }

  var offset = c - val / 100 * c;

  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SVG, { viewBox: "0 0 20 20", version: "1.1", xmlns: "http://www.w3.org/2000/svg", children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("circle", {
        r: r,
        cx: "10",
        cy: "10",
        fill: "transparent",
        strokeDasharray: "".concat(c, " ").concat(c),
        strokeDashoffset: "0" }), /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("circle", {
        id: "bar",
        r: r,
        cx: "10",
        cy: "10",
        fill: "transparent",
        strokeDasharray: "".concat(c, " ").concat(c),
        style: { strokeDashoffset: offset } })] }));



};

/* harmony default export */ __webpack_exports__["Z"] = (ProgressIcon);

/***/ }),

/***/ 82772:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31157);
/* harmony import */ var _components_form_Input2__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45330);
/* harmony import */ var _components_Icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54444);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);





var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].div.withConfig({ displayName: "Search__Wrapper", componentId: "sc-zz0z24-0" })(["position:relative;width:100%;border-bottom:1px solid #D8D8D8;margin-top:20px;margin-bottom:20px;"]);







var SearchIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(_components_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({ displayName: "Search__SearchIcon", componentId: "sc-zz0z24-1" })(["position:absolute;top:calc(50% - 8px);height:20px;"]);





var Input = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(_components_form_Input2__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({ displayName: "Search__Input", componentId: "sc-zz0z24-2" })(["color:#242424;line-height:1;border:none;padding:14px 24px 14px 30px;input:focus{background:none;}::placeholder{color:#242424;}"]);














var Search = function Search(_ref) {var handleChange = _ref.handleChange,placeholder = _ref.placeholder,_ref$value = _ref.value,value = _ref$value === void 0 ? '' : _ref$value;
  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(Wrapper, { children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(SearchIcon, { name: "ygb-icon-searchb", fontSize: "18px", color: "#000" }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Input, {
        name: "search",
        placeholder: placeholder,
        onChange: function onChange(e) {return handleChange(e.target.value);},
        value: value })] }));



};

/* harmony default export */ __webpack_exports__["Z"] = (Search);

/***/ }),

/***/ 73074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _organisms_modals_LoginModal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77495);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);
var _excluded = ["open"];function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}


var useLoginModal = function useLoginModal()


{var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var _ref$open = _ref.open,open = _ref$open === void 0 ? false : _ref$open,props = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(open),isOpen = _useState[0],setOpen = _useState[1];

  var content = /*#__PURE__*/
  (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_organisms_modals_LoginModal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread({}, props), {}, { open: isOpen, onClose: function onClose() {return setOpen(false);} }));


  return [
  content,
  {
    isOpen: isOpen,
    openModal: function openModal() {return setOpen(true);},
    closeModal: function closeModal() {return setOpen(false);} }];


};

/* harmony default export */ __webpack_exports__["Z"] = (useLoginModal);

/***/ }),

/***/ 38198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90116);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17674);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31157);
/* harmony import */ var _components_Icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54444);
/* harmony import */ var _components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94007);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);





var Language = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].button.withConfig({ displayName: "Languages__Language", componentId: "sc-2xcrxo-0" })(["flex-shrink:0;position:relative;width:30px;height:30px;border:1px solid ", ";border-radius:50%;padding:1px;margin-left:14px;background:none;box-sizing:border-box;cursor:pointer;outline:none;i{position:absolute;top:0;right:0;border:1px solid #129EDC;border-radius:50%;padding:2px;background-color:white;transform:translate(25%,-25%);}"],




function (_ref) {var selected = _ref.selected;return selected ? '#129EDC' : 'transparent';});




















var LanguageImage = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].img.withConfig({ displayName: "Languages__LanguageImage", componentId: "sc-2xcrxo-1" })(["width:100%;"]);



var available_languages = {
  se: '/static/icons/se.png',
  en: '/static/icons/en.png',
  no: '/static/icons/no.png',
  fi: '/static/icons/fi.png' };









var Languages = function Languages(_ref2)



{var onChange = _ref2.onChange,_ref2$languages = _ref2.languages,languages = _ref2$languages === void 0 ? null : _ref2$languages,_ref2$enabledLanguage = _ref2.enabledLanguages,enabledLanguages = _ref2$enabledLanguage === void 0 ? ['se', 'en'] : _ref2$enabledLanguage;
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(
  languages || Object.keys(available_languages)),selectedLanguages = _useState[0],setSelectedLanguages = _useState[1];


  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, { children:
      Object.entries(available_languages).map(function (_ref3) {var _ref4 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref3, 2),key = _ref4[0],path = _ref4[1];
        if (!enabledLanguages.includes(key)) {
          return null;
        }
        var selected = selectedLanguages.includes(key);
        return /*#__PURE__*/(
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(Language, {

            selected: selected,
            onClick: function onClick() {
              var langs = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(selectedLanguages);
              if (selected) {
                // we always want one item selected
                if (selectedLanguages.length > 1) {
                  langs = langs.filter(function (lang) {return lang !== key;});
                }
              } else {
                langs.push(key);
              }

              setSelectedLanguages((0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(langs));
              onChange((0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(langs));
            }, children: [/*#__PURE__*/

            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(LanguageImage, { src: path }),
            selected ? /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_Icon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, { name: "ygb-icon-checkmark", fontSize: "8px", color: "#129EDC" }) :
            null] }, key));


      }) }));


};

/* harmony default export */ __webpack_exports__["Z"] = (Languages);

/***/ }),

/***/ 70021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31157);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97878);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}




var TrailerWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].div.withConfig({ displayName: "Trailer__TrailerWrapper", componentId: "sc-191tqp1-0" })(["flex:1;position:relative;height:auto;padding-top:calc(", "%);@media (min-width:", "px){min-width:350px;}"],



function () {return (100 / 1.777).toFixed(2);},

function (_ref) {var theme = _ref.theme;return theme.viewports.tablet;});




var TrailerVideo = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(_index__WEBPACK_IMPORTED_MODULE_2__["default"]).withConfig({ displayName: "Trailer__TrailerVideo", componentId: "sc-191tqp1-1" })(["position:absolute;top:0;left:0;width:100%;height:100%;"]);

















var Trailer = function Trailer(props) {
  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(TrailerWrapper, { children: /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(TrailerVideo, _objectSpread({}, props)) }));


};

/* harmony default export */ __webpack_exports__["Z"] = (Trailer);

/***/ }),

/***/ 17360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ live; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@lingui/core/esm/index.js + 1 modules
var esm = __webpack_require__(94471);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(31157);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@lingui/react/esm/index.js + 1 modules
var react_esm = __webpack_require__(85169);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./ecosystems/landing_pages/hero/Hero.tsx
var Hero = __webpack_require__(83689);
// EXTERNAL MODULE: ./ecosystems/landing_pages/hero/components.ts
var components = __webpack_require__(23502);
// EXTERNAL MODULE: ./components/layout/Grid.ts
var Grid = __webpack_require__(94007);
// EXTERNAL MODULE: ./components/MessageStripe.tsx
var MessageStripe = __webpack_require__(35281);
// EXTERNAL MODULE: ./components/MetaTags.tsx
var MetaTags = __webpack_require__(9128);
// EXTERNAL MODULE: ./ecosystems/events/Search.tsx
var Search = __webpack_require__(82772);
// EXTERNAL MODULE: ./ecosystems/events/EventListingCard.tsx
var EventListingCard = __webpack_require__(43725);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(90116);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71383);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(12922);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(37887);
// EXTERNAL MODULE: ./node_modules/react-media/esm/react-media.js
var react_media = __webpack_require__(87784);
// EXTERNAL MODULE: ./components/form/Select.tsx
var Select = __webpack_require__(76611);
// EXTERNAL MODULE: ./organisms/Languages.tsx
var Languages = __webpack_require__(38198);
// EXTERNAL MODULE: ./components/Icon.tsx
var Icon = __webpack_require__(54444);
// EXTERNAL MODULE: ./organisms/modals/base/index.tsx + 3 modules
var base = __webpack_require__(10842);
// EXTERNAL MODULE: ./lib/constants.tsx
var constants = __webpack_require__(22498);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./ecosystems/events/EventsFilter.tsx
var _templateObject;












var Filters = styled_components_browser_esm["default"].div.withConfig({ displayName: "EventsFilter__Filters", componentId: "sc-1yn2qh5-0" })(["position:sticky;top:0;padding:10px 20px;background-color:#F0F5FB;box-shadow:2px 2px 4px #09080838;z-index:9;"]);








var EventsFilter_Select = (0,styled_components_browser_esm["default"])(Select/* default */.Z).withConfig({ displayName: "EventsFilter__Select", componentId: "sc-1yn2qh5-1" })(["background-color:white;.MuiInputBase-root{.MuiSelect-select{font-size:13px;border:solid 1px #dddddd;border-radius:5px;padding:10px 35px 10px 14px;}.MuiSelect-icon{right:5px;}}"]);
















var MobileFilterOpen = styled_components_browser_esm["default"].button.withConfig({ displayName: "EventsFilter__MobileFilterOpen", componentId: "sc-1yn2qh5-2" })(["border:1px solid lightgrey;border-radius:3px;padding:12px 20px;margin:0 auto;background-color:white;"]);







var INSTRUCTORS_QUERY = (0,lib/* gql */.Ps)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  query instructors {\n    instructors(option: live_events_instructors_only, perPage: 100, page: 1) {\n      data {\n        name\n        slug\n      }\n    }\n  }\n"])));










var sortOptions = [
{
  label: /*#__PURE__*/(0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "live.listings_page.filters.sort_label" }),
  value: '-1' },

{
  label: /*#__PURE__*/(0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "live.listings_page.filters.sort_by_date" }),
  value: 'first_event_date' },

{
  label: /*#__PURE__*/(0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "live.listings_page.filters.sort_by_price" }),
  value: 'amount_cents' }];



var FilterInputs = function FilterInputs(_ref)










{var _ref2;var isMobile = _ref.isMobile,_ref$languages = _ref.languages,languages = _ref$languages === void 0 ? ['se', 'en'] : _ref$languages,instructor = _ref.instructor,sortBy = _ref.sortBy,kind = _ref.kind,kinds = _ref.kinds,onLanguageChange = _ref.onLanguageChange,onInstructorChange = _ref.onInstructorChange,onSortChange = _ref.onSortChange,onKindChange = _ref.onKindChange;
  var _useQuery = (0,useQuery/* useQuery */.a)(

  INSTRUCTORS_QUERY),instructorsData = _useQuery.data,instructorsError = _useQuery.error;

  var mt = isMobile ? 20 : 0;
  var direction = isMobile ? 'column' : 'row';

  return /*#__PURE__*/(
    (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [/*#__PURE__*/
      (0,jsx_runtime.jsxs)(Grid/* Flex */.kC, { flexDirection: direction, children: [/*#__PURE__*/
        (0,jsx_runtime.jsx)(Grid/* Box */.xu, { mr: 10, mt: mt, children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(EventsFilter_Select, {
            name: "sort",
            options: sortOptions,
            valueKey: "value",
            displayTextKey: "label",
            selectedValue: sortBy === null ? '-1' : sortBy,
            onChange: function onChange(e) {
              var value = e.target.value;
              onSortChange(value === '-1' ? null : value);
            } }) }),


        !instructorsError ? /*#__PURE__*/
        (0,jsx_runtime.jsx)(Grid/* Box */.xu, { mr: 10, mt: mt, children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(EventsFilter_Select, {
            name: "instructors",
            options: [
            {
              label: /*#__PURE__*/(0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "live.listings_page.filters.instructors" }),
              value: '-1' }].concat((0,toConsumableArray/* default */.Z)(

            ((instructorsData === null || instructorsData === void 0 ? void 0 : instructorsData.instructors.data) || []).map(
            function (instructor) {return {
                label: instructor.name,
                value: instructor.slug };}))),



            valueKey: "value",
            displayTextKey: "label",
            selectedValue: instructor === null ? '-1' : instructor,
            onChange: function onChange(e) {
              var instructor = e.target.value;
              onInstructorChange(instructor === '-1' ? null : instructor);
            } }) }) :


        null, /*#__PURE__*/
        (0,jsx_runtime.jsx)(Grid/* Box */.xu, { mr: 10, mt: mt, children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(EventsFilter_Select, {
            name: "kind",
            options: [
            {
              label: /*#__PURE__*/(0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "live.listings_page.filters.kind_label" }),
              value: '-1' }].concat((0,toConsumableArray/* default */.Z)((_ref2 =

            kinds || []) === null || _ref2 === void 0 ? void 0 : _ref2.map(function (kind) {return {
                label: constants/* LIVE_KINDS */.sU[kind],
                value: kind };}))),


            valueKey: "value",
            displayTextKey: "label",
            selectedValue: kind === null ? '-1' : kind,
            onChange: function onChange(e) {
              var value = e.target.value;
              onKindChange(value === '-1' ? null : value);
            } }) })] }), /*#__PURE__*/



      (0,jsx_runtime.jsxs)(Grid/* Flex */.kC, {
        mt: mt,
        flex: 1,
        justifyContent: isMobile ? 'center' : 'flex-end',
        alignItems: "center", children: [/*#__PURE__*/

        (0,jsx_runtime.jsxs)("span", { children: [/*#__PURE__*/
          (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "live.listings_page.filters.languages" }), ":"] }), /*#__PURE__*/

        (0,jsx_runtime.jsx)(Languages/* default */.Z, { languages: languages, onChange: onLanguageChange })] })] }));



};

var FilterModal = function FilterModal(_ref3)










{var languages = _ref3.languages,instructor = _ref3.instructor,sortBy = _ref3.sortBy,kind = _ref3.kind,kinds = _ref3.kinds,onLanguageChange = _ref3.onLanguageChange,onInstructorChange = _ref3.onInstructorChange,onSortChange = _ref3.onSortChange,onKindChange = _ref3.onKindChange,onClose = _ref3.onClose;
  return /*#__PURE__*/(
    (0,jsx_runtime.jsxs)(base/* Modal */.u_, { open: true, children: [/*#__PURE__*/
      (0,jsx_runtime.jsx)(base/* Header */.h4, { handleClose: onClose, children: /*#__PURE__*/
        (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "live.listings_page.filters.sort_modal_title" }) }), /*#__PURE__*/

      (0,jsx_runtime.jsx)(base/* Body */.uT, { children: /*#__PURE__*/
        (0,jsx_runtime.jsx)(Grid/* Flex */.kC, { flexDirection: "column-reverse", children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(FilterInputs, {
            languages: languages,
            instructor: instructor,
            sortBy: sortBy,
            kind: kind,
            kinds: kinds,
            onInstructorChange: onInstructorChange,
            onLanguageChange: onLanguageChange,
            onSortChange: onSortChange,
            onKindChange: onKindChange,
            isMobile: true }) }) })] }));





};














var EventsFilters = function EventsFilters(props) {
  var _props$className =










  props.className,className = _props$className === void 0 ? '' : _props$className,languages = props.languages,instructor = props.instructor,sortBy = props.sortBy,kinds = props.kinds,kind = props.kind,onLanguageChange = props.onLanguageChange,onInstructorChange = props.onInstructorChange,onSortChange = props.onSortChange,onKindChange = props.onKindChange;
  var theme = (0,react.useContext)(styled_components_browser_esm.ThemeContext);
  var _useState = (0,react.useState)(false),isModalOpen = _useState[0],openModal = _useState[1];

  return /*#__PURE__*/(
    (0,jsx_runtime.jsx)(Filters, { className: className, children: /*#__PURE__*/
      (0,jsx_runtime.jsx)(Grid/* Container */.W2, { flexWrap: "wrap", children: /*#__PURE__*/
        (0,jsx_runtime.jsx)(react_media/* default */.Z, { query: "(min-width: ".concat(theme.viewports.tablet, "px)"), children:
          function children(matches) {
            if (matches) {
              return /*#__PURE__*/(
                (0,jsx_runtime.jsx)(FilterInputs, {
                  languages: languages,
                  instructor: instructor,
                  sortBy: sortBy,
                  kind: kind,
                  kinds: kinds,
                  onInstructorChange: onInstructorChange,
                  onLanguageChange: onLanguageChange,
                  onSortChange: onSortChange,
                  onKindChange: onKindChange,
                  isMobile: false }));


            } else {
              return /*#__PURE__*/(
                (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [/*#__PURE__*/
                  (0,jsx_runtime.jsxs)(MobileFilterOpen, {
                    onClick: function onClick() {
                      openModal(true);
                    }, children: [/*#__PURE__*/

                    (0,jsx_runtime.jsx)(Icon/* default */.Z, { name: "ygb-icon-restart" }), ' ', /*#__PURE__*/
                    (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "live.listings_page.filters.sort_mobile_label" })] }),

                  isModalOpen ? /*#__PURE__*/
                  (0,jsx_runtime.jsx)(FilterModal, {
                    languages: languages,
                    instructor: instructor,
                    sortBy: sortBy,
                    kind: kind,
                    kinds: kinds,
                    onInstructorChange: onInstructorChange,
                    onLanguageChange: onLanguageChange,
                    onSortChange: onSortChange,
                    onKindChange: onKindChange,
                    onClose: function onClose() {return openModal(false);} }) :

                  null] }));


            }
          } }) }) }));




};

/* harmony default export */ var EventsFilter = (EventsFilters);
// EXTERNAL MODULE: ./assets/ArrowRightIcon.js
var ArrowRightIcon = __webpack_require__(210);
// EXTERNAL MODULE: ./gql/generated/index.tsx
var generated = __webpack_require__(48354);
// EXTERNAL MODULE: ./components/Spinner.tsx
var Spinner = __webpack_require__(24452);
// EXTERNAL MODULE: ./components/buttons.js
var buttons = __webpack_require__(49613);
// EXTERNAL MODULE: ./lib/contexts/UserProvider.tsx
var UserProvider = __webpack_require__(47493);
// EXTERNAL MODULE: ./components/EmptyResults.tsx
var EmptyResults = __webpack_require__(87977);
// EXTERNAL MODULE: ./organisms/video-player/Trailer.tsx
var Trailer = __webpack_require__(70021);
// EXTERNAL MODULE: ./ecosystems/pricing/PricingSection.tsx + 2 modules
var PricingSection = __webpack_require__(27352);
// EXTERNAL MODULE: ./lib/apollo/policies/index.ts + 23 modules
var policies = __webpack_require__(54734);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parse/index.js + 41 modules
var parse = __webpack_require__(35337);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isFuture/index.js
var isFuture = __webpack_require__(82644);
// EXTERNAL MODULE: ./lib/contexts/languageContext.js
var languageContext = __webpack_require__(17516);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./ecosystems/events/LiveCodesAvailableCard.tsx











var Card = (0,styled_components_browser_esm["default"])(Grid/* Flex */.kC).withConfig({ displayName: "LiveCodesAvailableCard__Card", componentId: "sc-1uvsx4o-0" })(["color:#243240;border-radius:4px;background-color:#f0f5fb;& ~ .Live--LiveCard:nth-of-type(12n):last-of-type{display:none;}"]);









var Title = styled_components_browser_esm["default"].p.withConfig({ displayName: "LiveCodesAvailableCard__Title", componentId: "sc-1uvsx4o-1" })(["font-size:14px;font-weight:600;line-height:22px;margin:0 0 10px;"]);






var Body = styled_components_browser_esm["default"].p.withConfig({ displayName: "LiveCodesAvailableCard__Body", componentId: "sc-1uvsx4o-2" })(["font-size:16px;line-height:22px;text-align:center;margin:0 0 10px;"]);






var SubTitle = styled_components_browser_esm["default"].p.withConfig({ displayName: "LiveCodesAvailableCard__SubTitle", componentId: "sc-1uvsx4o-3" })(["font-size:14px;line-height:22px;margin:0 0 10px;opacity:0.8;"]);






var checkLiveCodeValidity = function checkLiveCodeValidity(liveEvent) {var _liveEvent$usedIn;
  //
  var expirationDate = (0,parse/* default */.Z)(
  liveEvent.expirationDate,
  'yyyy-MM-dd',
  new Date());

  return (
    (0,isFuture/* default */.Z)(expirationDate) && ((_liveEvent$usedIn = liveEvent.usedIn) === null || _liveEvent$usedIn === void 0 ? void 0 : _liveEvent$usedIn.length) < liveEvent.usageLimit);

};

var LiveCodesAvailableCard = function LiveCodesAvailableCard() {
  var lang = (0,react.useContext)(languageContext/* default */.Z);
  var _useContext = (0,react.useContext)(UserProvider/* UserContext */.S),currentUser = _useContext[0];
  var _useLiveEventCodesLaz = (0,generated/* useLiveEventCodesLazyQuery */.PC6)(),_useLiveEventCodesLaz2 = (0,slicedToArray/* default */.Z)(_useLiveEventCodesLaz, 2),loadLiveEventCodes = _useLiveEventCodesLaz2[0],data = _useLiveEventCodesLaz2[1].data;
  //

  (0,react.useEffect)(function () {
    if (currentUser !== null && currentUser !== void 0 && currentUser.id) {
      loadLiveEventCodes();
    }
  }, [currentUser === null || currentUser === void 0 ? void 0 : currentUser.id]);

  var hasAvailableLiveCodes = (0,react.useMemo)(function () {var _data$liveEventCodes, _data$liveEventCodes$, _data$liveEventCodes4, _data$liveEventCodes5;
    var hasValidTrialCodes = false,
    hasValidWellnessCodes = false;

    if ((data === null || data === void 0 ? void 0 : (_data$liveEventCodes = data.liveEventCodes) === null || _data$liveEventCodes === void 0 ? void 0 : (_data$liveEventCodes$ = _data$liveEventCodes.trial) === null || _data$liveEventCodes$ === void 0 ? void 0 : _data$liveEventCodes$.length) > 0) {var _data$liveEventCodes2, _data$liveEventCodes3;
      hasValidTrialCodes = data === null || data === void 0 ? void 0 : (_data$liveEventCodes2 = data.liveEventCodes) === null || _data$liveEventCodes2 === void 0 ? void 0 : (_data$liveEventCodes3 = _data$liveEventCodes2.trial) === null || _data$liveEventCodes3 === void 0 ? void 0 : _data$liveEventCodes3.some(
      checkLiveCodeValidity);

    }

    if ((data === null || data === void 0 ? void 0 : (_data$liveEventCodes4 = data.liveEventCodes) === null || _data$liveEventCodes4 === void 0 ? void 0 : (_data$liveEventCodes5 = _data$liveEventCodes4.wellness) === null || _data$liveEventCodes5 === void 0 ? void 0 : _data$liveEventCodes5.length) > 0) {var _data$liveEventCodes6, _data$liveEventCodes7;
      //
      hasValidWellnessCodes = data === null || data === void 0 ? void 0 : (_data$liveEventCodes6 = data.liveEventCodes) === null || _data$liveEventCodes6 === void 0 ? void 0 : (_data$liveEventCodes7 = _data$liveEventCodes6.wellness) === null || _data$liveEventCodes7 === void 0 ? void 0 : _data$liveEventCodes7.some(
      checkLiveCodeValidity);

    }

    return hasValidTrialCodes || hasValidWellnessCodes;
  }, [data === null || data === void 0 ? void 0 : data.liveEventCodes]);

  if (!hasAvailableLiveCodes) {
    return null;
  }

  return /*#__PURE__*/(
    (0,jsx_runtime.jsxs)(Card, {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      px: [10, 10, 20],
      py: 40, children: [/*#__PURE__*/


      (0,jsx_runtime.jsx)(Title, { children: /*#__PURE__*/
        (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "live.listings.live_codes_card.title" }) }), /*#__PURE__*/

      (0,jsx_runtime.jsx)(Body, { children: /*#__PURE__*/
        (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "live.listings.live_codes_card.description" }) }), /*#__PURE__*/

      (0,jsx_runtime.jsx)(SubTitle, { children: /*#__PURE__*/
        (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "live.listings.live_codes_card.description2" }) }), /*#__PURE__*/

      (0,jsx_runtime.jsx)((link_default()), { href: "/".concat(lang, "/me/settings/live-codes"), passHref: true, children: /*#__PURE__*/
        (0,jsx_runtime.jsx)(buttons/* default */.ZP, { children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "live.listings.live_codes_card.see_code_btn" }) }) })] }));




};
;// CONCATENATED MODULE: ./pages/[lang]/live/index.tsx
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,defineProperty/* default */.Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}


























var live_MessageStripe = (0,styled_components_browser_esm["default"])(MessageStripe/* default */.ZP).withConfig({ displayName: "live__MessageStripe", componentId: "sc-147gls0-0" })(["p{display:flex;align-items:center;margin:10px auto;}a{display:flex;align-items:center;svg{flex-shrink:0;width:20px;height:20px;margin-left:10px;}}"]);



















var HeroSection = (0,styled_components_browser_esm["default"])(Hero/* default */.Z).withConfig({ displayName: "live__HeroSection", componentId: "sc-147gls0-1" })(["", "{padding-right:8%;margin:0 auto;", "{max-width:720px;}", "{display:flex;align-items:center;font-size:34px;color:white;line-height:1.2;margin-bottom:0px;}", "{font-size:20px;color:white;line-height:1.5;margin-top:24px;margin-bottom:24px;}", "{font-size:13px;color:white;margin-top:10px;}@media (max-width:", "px){", "{font-size:24px;}margin-top:20px;}@media (max-width:", "px){padding-right:0;}}", "{display:flex;align-items:center;border-radius:5px;overflow:hidden;}"],
components/* TextWrapper */.OP,



components/* TextWrapperInner */.z5,



components/* Title */.Dx,








components/* SubTitle */.DK,







components/* Disclaimer */.em,





function (props) {return props.theme.viewports.tablet;},
components/* Title */.Dx,





function (props) {return props.theme.viewports.mobile;},




components/* VideoWrapper */.U1);







var Cards = styled_components_browser_esm["default"].div.withConfig({ displayName: "live__Cards", componentId: "sc-147gls0-2" })(["display:grid;grid-template-columns:repeat(auto-fill,minmax(280px,1fr));grid-column-gap:20px;grid-row-gap:20px;"]);






var LoadMore = (0,styled_components_browser_esm["default"])(buttons/* default */.ZP).withConfig({ displayName: "live__LoadMore", componentId: "sc-147gls0-3" })(["color:#242424;border:1px solid #979797;border-radius:3px;padding:12px 24px;background:none;"]);







var heroVideo = {
  id: '53c57b2b-c38e-432e-9de8-2165e8408183',
  identifier: '73sk',
  content: { title: 'live page trailer' },
  thumbnailUrl:
  'https://yogobe.23video.com/64968561/68827179/468592ff9e3125f8c1d304191cf6e473//livetestimonials1920x1080-1mp4-thumbnail.jpglarge/embed/thumbnail.jpg',
  hls:
  'https://yogobe.23video.com/64968561/68827179/5004611f96a9fce75d7172ae84c44574/video_hls/playlist.m3u8',
  player: {
    hasAccess: true,
    assets: [
    {
      src:
      'https://yogobe.23video.com/64968561/68827179/5004611f96a9fce75d7172ae84c44574/video_mobile_high/livetestimonials1920x1080-1mp4-video.mp4',
      resolution: 180,
      size: 1335979 },

    {
      src:
      'https://yogobe.23video.com/64968561/68827179/5004611f96a9fce75d7172ae84c44574/video_medium/livetestimonials1920x1080-1mp4-video.mp4',
      resolution: 360,
      size: 2533181 },

    {
      src:
      'https://yogobe.23video.com/64968561/68827179/5004611f96a9fce75d7172ae84c44574/video_hd/livetestimonials1920x1080-1mp4-video.mp4',
      resolution: 720,
      size: 4340728 },

    {
      src:
      'https://yogobe.23video.com/64968561/68827179/5004611f96a9fce75d7172ae84c44574/video_1080p/livetestimonials1920x1080-1mp4-video.mp4',
      resolution: 1080,
      size: 10835454 }] } };





var buildFilters = function buildFilters(query) {
  var languages = query !== null && query !== void 0 && query.languages ? [query.languages].flat() : ['en', 'se'];
  return {
    search: (query === null || query === void 0 ? void 0 : query.search) || '',
    languages: languages,
    instructor: (query === null || query === void 0 ? void 0 : query.instructor) || null,
    kind: (query === null || query === void 0 ? void 0 : query.kind) || null,
    sortBy: (query === null || query === void 0 ? void 0 : query.sortBy) || null };

};

var EventsListings = function EventsListings(_ref) {var _currentUser$liveEven, _heroVideo$player, _data$liveEvents2;var pageProps = _ref.pageProps;
  var router = (0,next_router.useRouter)();
  var query = router.query;
  var _useState = (0,react.useState)(buildFilters(query)),filters = _useState[0],setFilters = _useState[1];
  var _useContext = (0,react.useContext)(UserProvider/* UserContext */.S),currentUser = _useContext[0];
  var _useState2 = (0,react.useState)(false),loadingMore = _useState2[0],setLoadingMore = _useState2[1];
  var _useLiveEventsQuery = (0,generated/* useLiveEventsQuery */.c2y)({
    variables: _objectSpread({
      page: 1 },
    (pageProps === null || pageProps === void 0 ? void 0 : pageProps.initialFilters) || {}),

    ssr: false }),data = _useLiveEventsQuery.data,loading = _useLiveEventsQuery.loading,fetchMore = _useLiveEventsQuery.fetchMore,refetch = _useLiveEventsQuery.refetch;


  var firstRender = (0,react.useRef)(true);
  var _useRef = (0,react.useRef)(
  (0,lodash.debounce)(
  function (_ref2) {var search = _ref2.search,languages = _ref2.languages,instructor = _ref2.instructor,sortBy = _ref2.sortBy,kind = _ref2.kind;
    refetch({
      search: search === '' ? '*' : search,
      languages: languages,
      instructor: instructor,
      sortBy: sortBy,
      kind: kind });

  },
  500,
  {
    maxWait: 3000,
    leading: false,
    trailing: true })),searchRef = _useRef.current;




  (0,react.useEffect)(function () {
    if (!firstRender.current) {
      searchRef({
        search: filters.search,
        languages: filters.languages,
        instructor: filters.instructor,
        sortBy: filters.sortBy,
        kind: filters.kind });

    } else {
      firstRender.current = false;
    }
  }, [
  filters.search,
  filters.languages,
  filters.instructor,
  filters.kind,
  filters.sortBy]);


  var loadMore = /*#__PURE__*/function () {var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {var _data$liveEvents;return regenerator_default().wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:
              setLoadingMore(true);_context.next = 3;return (
                fetchMore({
                  variables: { page: (data === null || data === void 0 ? void 0 : (_data$liveEvents = data.liveEvents) === null || _data$liveEvents === void 0 ? void 0 : _data$liveEvents.page) + 1 } }));case 3:

              setLoadingMore(false);case 4:case "end":return _context.stop();}}}, _callee);}));return function loadMore() {return _ref3.apply(this, arguments);};}();


  var clearFilters = function clearFilters() {
    setFilters({
      search: '',
      languages: [generated/* LanguageKind.En */.$PN.En, generated/* LanguageKind.Se */.$PN.Se],
      instructor: null,
      sortBy: null,
      kind: null });

    router.replace(
    {
      pathname: router.pathname,
      query: { lang: router.query.lang } },

    undefined,
    { shallow: true });

  };

  var updateFilters = function updateFilters(filter, value) {
    setFilters(_objectSpread(_objectSpread({}, filters), {}, (0,defineProperty/* default */.Z)({}, filter, value)));
    var query = _objectSpread(_objectSpread({},
    router.query), {}, (0,defineProperty/* default */.Z)({
      lang: router.query.lang },
    filter, value));

    if (!value) {
      // simplest way to delete from query & no have empty param
      delete query[filter];
    }
    router.replace(
    {
      pathname: router.pathname,
      query: query },

    undefined,
    { shallow: true });

    (0,policies/* snackbarVar */.Ck)({
      isSnackBarOpen: true,
      snackBarMessage: esm/* i18n._ */.ag._( /*i18n*/{ id: 'live.listings_page.filter_applied_toaster' }) });

  };

  var userResolved = currentUser === null || (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id);
  var userEvents =
  (currentUser === null || currentUser === void 0 ? void 0 : (_currentUser$liveEven = currentUser.liveEventsAccess) === null || _currentUser$liveEven === void 0 ? void 0 : _currentUser$liveEven.map(function (access) {return access.liveEvent.slug;})) || [];

  var liveEventsData = (data === null || data === void 0 ? void 0 : data.liveEvents) || (
  pageProps === null || pageProps === void 0 ? void 0 : pageProps.ssrEvents);

  var events = liveEventsData === null || liveEventsData === void 0 ? void 0 : liveEventsData.data;

  var content;
  if (!events || loading && !userResolved) {
    content = /*#__PURE__*/
    (0,jsx_runtime.jsx)(Grid/* Flex */.kC, { justifyContent: "center", alignItems: "center", mt: 50, children: /*#__PURE__*/
      (0,jsx_runtime.jsx)(Spinner/* default */.Z, { size: 28, spinnerColor: "#242424" }) });


  } else if ((events === null || events === void 0 ? void 0 : events.length) > 0) {var _liveEventsData$data;
    content = [/*#__PURE__*/
    (0,jsx_runtime.jsxs)(Cards, { children: [/*#__PURE__*/
      (0,jsx_runtime.jsx)(LiveCodesAvailableCard, {}),
      events === null || events === void 0 ? void 0 : events.map(function (event) {
        if (event.slug === 'yoga-nidra-for-mios-kundklubb') {
          return null;
        }
        return /*#__PURE__*/(
          (0,jsx_runtime.jsx)(EventListingCard/* default */.ZP, {
            className: "Live--LiveCard",

            event: event,
            hasAccess: userEvents.includes(event.slug) }, event.slug));


      })] }, 0)];



    if ((liveEventsData === null || liveEventsData === void 0 ? void 0 : liveEventsData.totalCount) > (liveEventsData === null || liveEventsData === void 0 ? void 0 : (_liveEventsData$data = liveEventsData.data) === null || _liveEventsData$data === void 0 ? void 0 : _liveEventsData$data.length)) {
      content.push( /*#__PURE__*/
      (0,jsx_runtime.jsx)(Grid/* Flex */.kC, { justifyContent: "center", mt: 40, children: /*#__PURE__*/
        (0,jsx_runtime.jsx)(LoadMore, {
          appearance: "outline",
          onClick: loadMore,
          loading: loadingMore, children: /*#__PURE__*/

          (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "live.listings_page.load_more_btn" }) }) }, 1));



    }
  } else {
    content = /*#__PURE__*/
    (0,jsx_runtime.jsx)(EmptyResults/* default */.Z, {
      icon: "ygb-icon-playlist-empty-ic",
      description: /*#__PURE__*/(0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "live.listings_page.no_events_found" }),
      action: /*#__PURE__*/
      (0,jsx_runtime.jsx)(buttons/* default */.ZP, { appearance: "link", onClick: clearFilters, children: /*#__PURE__*/
        (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "live.listings_page.clear_events_filters" }) }) });




  }

  return /*#__PURE__*/(
    (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [/*#__PURE__*/
      (0,jsx_runtime.jsx)(MetaTags/* default */.Z, {
        title: "LIVE-online i realtid",
        description: "Yoga, tr\xE4na och meditera i realtid - med Yogobe LIVE. Praktisera tillsammans som ett Community under v\xE4gledning av Team Yogobe.",
        thumbnailUrl: "/static/live-meta-image.jpg" }), /*#__PURE__*/



      (0,jsx_runtime.jsx)("div", { children:
        currentUser !== null && currentUser !== void 0 && currentUser.isNoneTrialPremium ? /*#__PURE__*/
        (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/

        (0,jsx_runtime.jsx)(live_MessageStripe, { bg: "#C5EDFF", color: "#243240", closable: false, children: /*#__PURE__*/
          (0,jsx_runtime.jsxs)("a", { href: "#subscription-offers", children: [/*#__PURE__*/
            (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "live.listings_page.banner.subscription_discount_text" }), /*#__PURE__*/
            (0,jsx_runtime.jsx)(ArrowRightIcon/* default */.Z, {})] }) }) }), /*#__PURE__*/




      (0,jsx_runtime.jsx)("div", { style: { backgroundColor: '#243240', padding: '0 20px' }, children: /*#__PURE__*/
        (0,jsx_runtime.jsx)(Grid/* Container */.W2, { flexDirection: 'column', py: 40, children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(HeroSection, {
            title: /*#__PURE__*/
            (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, {
              id: "live.listings_page.hero_title",
              components: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {}, "0")] }),


            subtitle: /*#__PURE__*/(0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "live.listings_page.subtitle" }),
            actions: [
            {
              name: /*#__PURE__*/(0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "live.listings_page.explore_events_btn" }),
              theme: 'default-white',
              href: '#explore-events' }],


            video: /*#__PURE__*/
            (0,jsx_runtime.jsx)(Trailer/* default */.Z, {

              video: heroVideo,
              thumbnailImage: heroVideo === null || heroVideo === void 0 ? void 0 : heroVideo.thumbnailUrl,
              isLimited: false,
              autoPlay: false,
              videoSources: heroVideo === null || heroVideo === void 0 ? void 0 : (_heroVideo$player = heroVideo.player) === null || _heroVideo$player === void 0 ? void 0 : _heroVideo$player.assets,
              elementID: 'e54a7231-fd70-4a7b-9a00-3ffbafe19de3' }),



            disclaimer: /*#__PURE__*/(0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "live.listings_page.disclaimer" }),
            reverseColumns: true }) }) }), /*#__PURE__*/



      (0,jsx_runtime.jsxs)("div", { id: "explore-events", children: [/*#__PURE__*/
        (0,jsx_runtime.jsx)(EventsFilter, {
          languages: filters.languages,
          instructor: filters.instructor,
          sortBy: filters.sortBy,
          kind: filters.kind,
          kinds: data === null || data === void 0 ? void 0 : (_data$liveEvents2 = data.liveEvents) === null || _data$liveEvents2 === void 0 ? void 0 : _data$liveEvents2.availableKinds,
          onInstructorChange: function onInstructorChange(instructor) {
            updateFilters('instructor', instructor);
          },
          onLanguageChange: function onLanguageChange(langs) {return updateFilters('languages', langs);},
          onSortChange: function onSortChange(sortBy) {return updateFilters('sortBy', sortBy);},
          onKindChange: function onKindChange(kind) {return updateFilters('kind', kind);} }), /*#__PURE__*/

        (0,jsx_runtime.jsx)(Grid/* Container */.W2, { fullWidth: true, px: 20, children: /*#__PURE__*/
          (0,jsx_runtime.jsxs)(Grid/* Container */.W2, { flexDirection: "column", mb: 80, children: [/*#__PURE__*/
            (0,jsx_runtime.jsx)(Search/* default */.Z, {
              handleChange: function handleChange(value) {return updateFilters('search', value);},
              placeholder: /*i18n*/esm/* i18n._ */.ag._("live.listings_page.search_input_placeholder"),
              value: filters.search }),

            content] }) }), /*#__PURE__*/


        (0,jsx_runtime.jsx)("div", { children:
          currentUser !== null && currentUser !== void 0 && currentUser.isNoneTrialPremium ? /*#__PURE__*/
          (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/

          (0,jsx_runtime.jsx)(PricingSection/* default */.ZP, { id: "subscription-offers" }) })] })] }));





};var __N_SSP = true;







































/* harmony default export */ var live = (EventsListings);

/***/ }),

/***/ 19544:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/live",
      function () {
        return __webpack_require__(17360);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 87784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94578);
/* harmony import */ var _babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97326);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4942);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var invariant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41143);
/* harmony import */ var invariant__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(invariant__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var json2mq__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80973);
/* harmony import */ var json2mq__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(json2mq__WEBPACK_IMPORTED_MODULE_2__);









var MediaQueryListener =
/*#__PURE__*/
function () {
  function MediaQueryListener(targetWindow, query, listener) {
    var _this = this;

    this.nativeMediaQueryList = targetWindow.matchMedia(query);
    this.active = true; // Safari doesn't clear up listener with removeListener
    // when the listener is already waiting in the event queue.
    // Having an active flag to make sure the listener is not called
    // after we removeListener.

    this.cancellableListener = function () {
      _this.matches = _this.nativeMediaQueryList.matches;

      if (_this.active) {
        listener.apply(void 0, arguments);
      }
    };

    this.nativeMediaQueryList.addListener(this.cancellableListener);
    this.matches = this.nativeMediaQueryList.matches;
  }

  var _proto = MediaQueryListener.prototype;

  _proto.cancel = function cancel() {
    this.active = false;
    this.nativeMediaQueryList.removeListener(this.cancellableListener);
  };

  return MediaQueryListener;
}();

var queryType = prop_types__WEBPACK_IMPORTED_MODULE_3___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_3___default().string), (prop_types__WEBPACK_IMPORTED_MODULE_3___default().object), prop_types__WEBPACK_IMPORTED_MODULE_3___default().arrayOf((prop_types__WEBPACK_IMPORTED_MODULE_3___default().object.isRequired))]);
/**
 * Conditionally renders based on whether or not a media query matches.
 */

var Media =
/*#__PURE__*/
function (_React$Component) {
  (0,_babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(Media, _React$Component);

  function Media(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_this)), "queries", []);

    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_this)), "getMatches", function () {
      var result = _this.queries.reduce(function (acc, _ref) {
        var _extends2;

        var name = _ref.name,
            mqListener = _ref.mqListener;
        return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, acc, (_extends2 = {}, _extends2[name] = mqListener.matches, _extends2));
      }, {}); // return result;


      return unwrapSingleQuery(result);
    });

    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_this)), "updateMatches", function () {
      var newMatches = _this.getMatches();

      _this.setState(function () {
        return {
          matches: newMatches
        };
      }, _this.onChange);
    });

    !(!(!props.query && !props.queries) || props.query && props.queries) ?  false ? 0 : invariant__WEBPACK_IMPORTED_MODULE_1___default()(false) : void 0;
    !(props.defaultMatches === undefined || !props.query || typeof props.defaultMatches === "boolean") ?  false ? 0 : invariant__WEBPACK_IMPORTED_MODULE_1___default()(false) : void 0;
    !(props.defaultMatches === undefined || !props.queries || typeof props.defaultMatches === "object") ?  false ? 0 : invariant__WEBPACK_IMPORTED_MODULE_1___default()(false) : void 0;

    if (typeof window !== "object") {
      // In case we're rendering on the server, apply the default matches
      var matches;

      if (props.defaultMatches !== undefined) {
        matches = props.defaultMatches;
      } else if (props.query) {
        matches = true;
      }
      /* if (props.queries) */
      else {
          matches = Object.keys(_this.props.queries).reduce(function (acc, key) {
            var _extends3;

            return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, acc, (_extends3 = {}, _extends3[key] = true, _extends3));
          }, {});
        }

      _this.state = {
        matches: matches
      };
      return (0,_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_this);
    }

    _this.initialize(); // Instead of calling this.updateMatches, we manually set the initial state to prevent
    // calling setState, which could trigger an unnecessary second render


    _this.state = {
      matches: _this.props.defaultMatches !== undefined ? _this.props.defaultMatches : _this.getMatches()
    };

    _this.onChange();

    return _this;
  }

  var _proto = Media.prototype;

  _proto.initialize = function initialize() {
    var _this2 = this;

    var targetWindow = this.props.targetWindow || window;
    !(typeof targetWindow.matchMedia === "function") ?  false ? 0 : invariant__WEBPACK_IMPORTED_MODULE_1___default()(false) : void 0;
    var queries = this.props.queries || wrapInQueryObject(this.props.query);
    this.queries = Object.keys(queries).map(function (name) {
      var query = queries[name];
      var qs = typeof query !== "string" ? json2mq__WEBPACK_IMPORTED_MODULE_2___default()(query) : query;
      var mqListener = new MediaQueryListener(targetWindow, qs, _this2.updateMatches);
      return {
        name: name,
        mqListener: mqListener
      };
    });
  };

  _proto.componentDidMount = function componentDidMount() {
    this.initialize(); // If props.defaultMatches has been set, ensure we trigger a two-pass render.
    // This is useful for SSR with mismatching defaultMatches vs actual matches from window.matchMedia
    // Details: https://github.com/ReactTraining/react-media/issues/81

    if (this.props.defaultMatches !== undefined) {
      this.updateMatches();
    }
  };

  _proto.onChange = function onChange() {
    var onChange = this.props.onChange;

    if (onChange) {
      onChange(this.state.matches);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.queries.forEach(function (_ref2) {
      var mqListener = _ref2.mqListener;
      return mqListener.cancel();
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        render = _this$props.render;
    var matches = this.state.matches;
    var isAnyMatches = typeof matches === "object" ? Object.keys(matches).some(function (key) {
      return matches[key];
    }) : matches;
    return render ? isAnyMatches ? render(matches) : null : children ? typeof children === "function" ? children(matches) : !Array.isArray(children) || children.length // Preact defaults to empty children array
    ? isAnyMatches ? // We have to check whether child is a composite component or not to decide should we
    // provide `matches` as a prop or not
    react__WEBPACK_IMPORTED_MODULE_0__.Children.only(children) && typeof react__WEBPACK_IMPORTED_MODULE_0__.Children.only(children).type === "string" ? react__WEBPACK_IMPORTED_MODULE_0__.Children.only(children) : react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(react__WEBPACK_IMPORTED_MODULE_0__.Children.only(children), {
      matches: matches
    }) : null : null : null;
  };

  return Media;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);
/**
 * Wraps a single query in an object. This is used to provide backward compatibility with
 * the old `query` prop (as opposed to `queries`). If only a single query is passed, the object
 * will be unpacked down the line, but this allows our internals to assume an object of queries
 * at all times.
 */


(0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(Media, "propTypes", {
  defaultMatches: prop_types__WEBPACK_IMPORTED_MODULE_3___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool), prop_types__WEBPACK_IMPORTED_MODULE_3___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool))]),
  query: queryType,
  queries: prop_types__WEBPACK_IMPORTED_MODULE_3___default().objectOf(queryType),
  render: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func),
  children: prop_types__WEBPACK_IMPORTED_MODULE_3___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_3___default().node), (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func)]),
  targetWindow: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().object),
  onChange: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func)
});

function wrapInQueryObject(query) {
  return {
    __DEFAULT__: query
  };
}
/**
 * Unwraps an object of queries, if it was originally passed as a single query.
 */


function unwrapSingleQuery(queryObject) {
  var queryNames = Object.keys(queryObject);

  if (queryNames.length === 1 && queryNames[0] === "__DEFAULT__") {
    return queryObject.__DEFAULT__;
  }

  return queryObject;
}

/* harmony default export */ __webpack_exports__["Z"] = (Media);


/***/ }),

/***/ 71169:
/***/ (function(module) {

var camel2hyphen = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

module.exports = camel2hyphen;

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2544,3088,4568,6394,5675,4924,8397,9437,4746,2661,8618,9774,2888,179], function() { return __webpack_exec__(19544); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);